import SmoothImage from 'components/_ui/SmoothImage'

export default function Background (props) {
  return (
    <SmoothImage
      alt=""
      sizes="100vw"
      { ...props }
      />
  )
}
